import { CountdownTime } from '../models/time.interface';

export function calculateDateDifference(endDay: Date = new Date()): CountdownTime {
  const end = endDay.valueOf();

  const millisecondsInSecond = 1000;
  const hoursInDay = 24;
  const minutesInHour = 60;
  const secondsInMinute = 60;

  const timeDifference = end - Date.now();

  const daysLeft = Math.floor(
    timeDifference / (millisecondsInSecond * minutesInHour * secondsInMinute * hoursInDay),
  );

  const hoursLeft = Math.floor(
    (timeDifference / (millisecondsInSecond * minutesInHour * secondsInMinute)) % hoursInDay,
  );

  const minutesLeft = Math.floor(
    (timeDifference / (millisecondsInSecond * minutesInHour)) % secondsInMinute,
  );

  const secondsLeft = Math.floor((timeDifference / millisecondsInSecond) % secondsInMinute);

  return { secondsLeft, minutesLeft, hoursLeft, daysLeft };
}
